import { Configuration, LogLevel, RedirectRequest, SilentRequest } from "@azure/msal-browser";

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID as string;
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID as string;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // localStorage (not sessionStorage) so the session survives closing the
    // tab / browser and is shared across tabs.  The user then stays signed in
    // up to the refresh-token lifetime (Entra caps SPA browser refresh tokens
    // at 24h) instead of being logged out the moment the tab closes.
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
      },
    },
  },
};

// Used for loginRedirect / acquireTokenRedirect
export const loginRequest: RedirectRequest = {
  scopes: [`api://${clientId}/access_as_user`],
};

// Used for acquireTokenSilent
export const silentRequest = (account: NonNullable<SilentRequest["account"]>): SilentRequest => ({
  scopes: [`api://${clientId}/access_as_user`],
  account,
});

export const apiScopes = [`api://${clientId}/access_as_user`];
